import mediumZoom from 'medium-zoom'

// Medium zoom
mediumZoom(document.querySelectorAll('[data-action="zoom"]'), {
  margin: 32
})



// WEBPACK FOOTER //
// ./src/js/modules/medium-zoom.js